import { Component, Fragment } from 'react';
import { Link, Router } from '../configs/routes';
import styles from '../styles/header.scss';
import { isDescendant } from '../utils';
import { CDN_CLRSAVE_URL } from '../constants';
import HeaderNav from './home/headerNav';
import base64 from 'base-64';
import getConfig from 'next/config';
import HomeSearchNew from './home/homeSearchNew';
const { publicRuntimeConfig } = getConfig();
/**
 * TODO
 * -  Refactor this component while creating the new component to remove unused
 *    code
 * -  Make staging and localhost also use new login sso
 */

interface Props {
  isUserLoggedIn: any;
  isPersonalisedPlanPage: boolean;
  hasSidebar: boolean;
  hasUserInvested: boolean;
  mandateList: any[];
  pendingActions: string[];
  url: any;
  hideHeaderSearch: boolean;
  showHeaderNavLinks?: boolean;
  isMobile?: boolean;
  showNudge: boolean;
  nudgeRequired: boolean;
}

interface State {
  isDropdownOpen: boolean;
  currentPath: string;
  showDropdown: boolean;
  openDropdown: boolean;
  mobileNavVisible: boolean;
}

class NavigationNew extends Component<Props, State> {
  public state: State = {
    isDropdownOpen: false,
    currentPath: '',
    showDropdown: false,
    openDropdown: false,
    mobileNavVisible: false,
  };

  public componentDidMount() {
    this.changeCurrentPath();
  }

  public changeMobileNav = (visibility: boolean) => {
    this.setState({
      mobileNavVisible: visibility,
    });
    document.body.style.overflow = visibility ? 'hidden' : 'auto';
  };

  public changeCurrentPath = () => {
    if (typeof location !== 'undefined') {
      document.addEventListener('click', this.toggleDropdown);
      if (location.pathname === '/save/login') {
        return this.setState({
          currentPath: location.search,
        });
      }
      this.setState({
        currentPath:
          location.pathname === '/save/login'
            ? location.search
            : `${location.pathname + location.search}`,
      });
    }
  };

  public UNSAFE_componentWillReceiveProps() {
    this.changeCurrentPath();
  }

  public componentWillUnmount() {
    document.removeEventListener('click', this.toggleDropdown);
  }

  public toggleDropdown = (e: any) => {
    e.stopPropagation();
    const { id = '', nodeName = '' } = e.target || {};
    if (
      (id === 'dropdown_trigger' ||
        isDescendant('dropdown_trigger', e.target)) &&
      !isDescendant('navbar-collapse', e.target)
    ) {
      this.setState({ isDropdownOpen: !this.state.isDropdownOpen });
    } else if (nodeName !== 'A') {
      this.setState({
        isDropdownOpen: false,
        showDropdown: false,
        openDropdown: false,
      });
    }
  };

  public showDropdown = (e: any) => {
    e.preventDefault();
    this.setState({ showDropdown: true });
  };
  public hideDropdown = (e: any) => {
    e.preventDefault();
    this.setState({ showDropdown: false });
  };
  public openDropdown = (a: any) => {
    a.preventDefault();
    this.setState({ openDropdown: true });
  };
  public closeDropdown = (a: any) => {
    a.preventDefault();
    this.setState({ openDropdown: false });
  };

  public handleClick = (e: any) => {
    document.body.style.overflow = 'auto';
    this.changeMobileNav(false);
    const { link, scroll } = e.target.dataset;
    if (link) {
      Router.pushRoute(`${link}`);
    } else if (scroll) {
      Router.pushRoute(`/save#${scroll}`);
    }
  };

  private handleLogout = async () => {
    try {
      if (typeof googleyolo !== 'undefined') {
        await googleyolo.disableAutoSignIn();
      }
    } catch (err) {}
    Router.push('/save/logout');
  };

  private renderLogo = () => {
    return (
      <Link href={{ pathname: '/save' }}>
        <a id="header-logo" className="lil-flex lil-items-center">
          <img
            className="lil-mr-6"
            width="110"
            title="Home: ClearTax"
            src="https://assets1.cleartax-cdn.com/cleartax/images/1642485730_blacklogoframe17334.png"
            alt="black"
          />
        </a>
      </Link>
    );
  };

  public render() {
    const { currentPath, openDropdown, mobileNavVisible } = this.state;
    let loginHref;
    let returnPath;
    switch (publicRuntimeConfig.env) {
      case 'development':
        loginHref = `/save/login?refer=${currentPath}`;
        // returnPath = base64.encode(
        //   `${currentPath}`
        // );
        // loginHref = `https://sso-dev-http.internal.cleartax.co/?product=save&return_path=${returnPath}`;
        break;
      case 'staging':
        loginHref = `/save/login?refer=${currentPath}`;
        // returnPath = base64.encode(
        //   `${currentPath}`
        // );
        // loginHref = `https://sso-staging-pub.internal.cleartax.co/?product=save&return_path=${returnPath}`;
        break;
      case 'production':
        returnPath = base64.encode(`${currentPath}`);
        loginHref = `https://accounts.cleartax.in/v2?product=save&return_path=${returnPath}`;
        break;
      default:
        loginHref = `/save/login?refer=${currentPath}`;
    }
    const {
      isUserLoggedIn,
      isPersonalisedPlanPage,
      hasUserInvested,
      hideHeaderSearch,
      showHeaderNavLinks,
      isMobile,
      showNudge,
      nudgeRequired,
    } = this.props;
    // const isMandatePending =
    //   pendingActions &&
    //   (pendingActions.includes('MANDATE') ||
    //     pendingActions.includes('MANDATE_DIRECT'));

    // Check mandate for direct only.
    // const isMandatePending =
    //   pendingActions && pendingActions.includes('MANDATE_DIRECT');
    // const isKYCPending = pendingActions && pendingActions.includes('KYC');
    // const isPennyDropPending =
    //   pendingActions && pendingActions.includes('PENNY_DROP_PENDING');
    return (
      <Fragment>
        {mobileNavVisible ? (
          <div className={`full-width full-height, ${styles['overlay']}`}>
            <div className={styles['nav-pane']}>
              <div className={styles['search-section']}>
                <p className="lil-pt-6">
                  Search from over 300+ top-performing Mutual Funds
                </p>
                <HomeSearchNew
                  fullWidth={true}
                  placeholder="Find a Mutual fund ..."
                  mobileNav={true}
                  hideSearchLabel={true}
                  afterSearch={() => this.changeMobileNav(false)}
                />
                <span
                  className={`
                    lil-cursor-pointer
                    lil-text-font-500
                    lil-text-s-24
                    ${styles['cross-button']}
                  `}
                  onClick={() => this.changeMobileNav(false)}
                >
                  {' '}
                  &#215;
                </span>
              </div>
              <ul className="lil-px-6 lil-pt-6" onClick={this.handleClick}>
                <li
                  className="lil-flex lil-items-center lil-pt-4"
                  data-link="/save"
                >
                  <img
                    data-link="/save"
                    className="lil-w-1/12"
                    src={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/mobile-nav-home.svg`}
                  />
                  <span
                    data-link="/save"
                    className="lil-w-11/12 lil-text-font-600 lil-text-s-18 lil-ml-4"
                  >
                    Home
                  </span>
                </li>

                <li
                  data-scroll="explore"
                  className="lil-flex lil-items-center lil-pt-4"
                >
                  <img
                    data-scroll="explore"
                    className="lil-w-1/12"
                    src={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/mobile-nav-award.svg`}
                  />
                  <span
                    data-scroll="explore"
                    className="lil-w-11/12 lil-text-font-600 lil-text-s-18 lil-ml-4"
                  >
                    Top Funds
                  </span>
                </li>

                {!isUserLoggedIn ? (
                  <li className={styles['mobile-nav-item']} key="login-logout">
                    <div className="lil-flex lil-mt-4">
                      <Link route={loginHref}>
                        <a className="lil-mr-6 lil-btn lil-btn-grey lg:lil-mr-2 md:lil-mr-1">
                          Login
                        </a>
                      </Link>
                      <Link route={loginHref}>
                        <a className="lil-btn lil-btn-blue">Signup</a>
                      </Link>
                    </div>
                  </li>
                ) : null}
              </ul>
              {isUserLoggedIn ? (
                <div
                  className="lil-mt-4 lil-pl-4"
                  onClick={() => {
                    document.body.style.overflow = 'auto';
                  }}
                >
                  <div className="lil-px-4 lil-py-2 lil-text-font-500 lil-text-s-20 lil-font-medium">
                    <Link route="/save/profile">
                      <a className="hover:lil-text-blue-350">Profile</a>
                    </Link>
                  </div>
                  {!isPersonalisedPlanPage ? (
                    <Fragment>
                      <div
                        id="nav-dashboard"
                        className="lil-px-4 lil-py-2 lil-text-font-500 lil-text-s-20 lil-font-medium"
                      >
                        <Link route="/save/dashboard/portfolio">
                          <a className="hover:lil-text-blue-350">Dashboard</a>
                        </Link>
                      </div>
                    </Fragment>
                  ) : null}
                  <div
                    id="nav-logout"
                    className="lil-px-4 lil-py-2 lil-text-font-500 lil-text-s-20 lil-font-medium"
                  >
                    <a
                      className="lil-text-font-500 lil-text-s-20 lil-font-semibold lil-cursor-pointer hover:lil-text-blue-350"
                      onClick={this.handleLogout}
                    >
                      Logout
                      {/* <span>{isUserLoggedIn.email}</span> */}
                    </a>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
        <nav
          className={`lil-nav ${
            showNudge && isMobile && nudgeRequired ? styles.top60 : ''
          }`}
          id="app-header"
        >
          <div className="lil-container lil-h-full lil-w-full lil-flex sm:lil-px-4">
            <div className="lil-flex lil-h-full lil-w-1/6 sm:lil-w-1/2">
              {this.renderLogo()}
            </div>
            <div className="lil-h-full lil-w-5/12 sm:lil-hidden">
              {!hideHeaderSearch && !showHeaderNavLinks ? (
                <HomeSearchNew fullWidth={true} hideSearchLabel={true} />
              ) : null}
              {showHeaderNavLinks ? (
                <HeaderNav
                  isMobile={isMobile}
                  hasUserInvested={hasUserInvested}
                />
              ) : null}
            </div>

            <div className="lil-flex lil-justify-end lil-items-center lil-pb-2 lil-h-full lil-w-5/12 sm:lil-w-1/2">
              <div className="sm:lil-hidden">
                <button className="lil-btn lil-mt-4 sm:lil-w-full sm:lil-mt-0">
                  <img
                    src="https://assets1.cleartax-cdn.com/cleartax/images/1603864316_playstoreblack.png"
                    width="24"
                  />
                  <a
                    className="sm:lil-hidden lil-px-3 lil-text-font-500 lil-font-extrabold"
                    href="https://play.google.com/store/apps/details?id=in.cleartax.consumer2&referrer=utm_source%3Dwebsite%26utm_medium%3Ditr-page-link%26utm_campaign%3Ditr-page"
                    target="_blank"
                  >
                    Download Black App
                  </a>
                </button>
              </div>

              <div className="lil-hidden sm:lil-flex lil-items-center">
                <div className="lil-mr-4">
                  <Link route="/save/search">
                    <a>
                      <img
                        src={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/search-icon-mf1.svg`}
                      />
                    </a>
                  </Link>
                </div>

                <div className="mobile-only--display small-2 columns">
                  <button onClick={() => this.changeMobileNav(true)}>
                    <div className="lil-toggle" id="mobile-header-toggle">
                      <div className="lil-toggle-bar"></div>
                      <div className="lil-toggle-bar"></div>
                      <div className="lil-toggle-bar lil-toggle-bar-half"></div>
                    </div>
                  </button>
                </div>
              </div>
              {isUserLoggedIn ? (
                <div className="lil-h-full sm:lil-hidden">
                  <div
                    className="lil-flex lil-items-center lil-h-full lil-dropdown lil-mx-6 lil-mt-2 md:lil-mx-1"
                    onMouseEnter={this.openDropdown}
                    onMouseLeave={this.closeDropdown}
                  >
                    <div className="lil-text-base lil-font-bold lil-nav-text lil-cursor-pointer">
                      My Account
                      <span className="lil-inline-block lil-caret lil-caret-down lil-ml-1 md:lil-ml-0"></span>
                    </div>

                    {openDropdown && (
                      <div
                        className="lil-shadow-sm lil-rounded-lg lil-fixed lil-mt-48 lil-bg-white"
                        style={{ width: '12rem' }}
                        id="navbar-collapse"
                        ref={(dropdown) => (this.dropdown = dropdown)}
                      >
                        <div className="lil-px-4 lil-py-2 lil-text-font-500 lil-text-s-20 lil-font-medium">
                          <Link route="/save/profile">
                            <a className="hover:lil-text-blue-350">Profile</a>
                          </Link>
                        </div>
                        {!isPersonalisedPlanPage ? (
                          <Fragment>
                            <div
                              id="nav-dashboard"
                              className="lil-px-4 lil-py-2 lil-text-font-500 lil-text-s-20 lil-font-medium"
                            >
                              <Link route="/save/dashboard/portfolio">
                                <a className="hover:lil-text-blue-350">
                                  Dashboard
                                </a>
                              </Link>
                            </div>
                          </Fragment>
                        ) : null}
                        <div
                          id="nav-logout"
                          className="lil-px-4 lil-py-2 lil-text-font-500 lil-text-s-20 lil-font-medium"
                        >
                          <a
                            className="lil-text-s-20 lil-font-medium lil-cursor-pointer hover:lil-text-blue-350"
                            onClick={this.handleLogout}
                          >
                            Logout
                            {/* <span>{isUserLoggedIn.email}</span> */}
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* <img
                            className={cx('user-icon', styles['img'])}
                            src="//assets1.cleartax-cdn.com/ct-frontend/images/nav-user-icon.svg"
                            alt="icon"
                          /> */}
                </div>
              ) : (
                <div className="lil-flex lil-pt-4 sm:lil-hidden">
                  <Link route={loginHref}>
                    <a className="lil-mx-6 lil-btn lil-btn-grey lg:lil-mx-2 md:lil-mx-1">
                      Login
                    </a>
                  </Link>
                  <Link route={loginHref}>
                    <a className="lil-btn lil-btn-blue">Signup</a>
                  </Link>
                </div>
              )}
            </div>
          </div>
        </nav>
      </Fragment>
    );
  }
}
export default NavigationNew;



// WEBPACK FOOTER //
// ./components/NavigationNew.tsx